module.exports = __webpack_public_path__ + "static/media/logocinzasombra.84ceb722.png";